module.exports = __webpack_public_path__ + "img/506.64d4001d.jpg";